<script setup lang="ts">
import Header from '@/components/TheHeader.vue'
import DashboardLayout from '@/components/layout/DashboardLayout.vue'
import CommonSuspenseWithToast from '@/components/ui/common/CommonSuspenseWithToast.vue'
</script>

<template>
  <div class="main-view">
    <div class="main-view__header">
      <Header />
    </div>
    <main class="main-view__main">
      <DashboardLayout>
        <CommonSuspenseWithToast>
          <RouterView v-slot="{ Component, route }">
            <Component
              :is="Component"
              :key="route.path"
            />
          </RouterView>
        </CommonSuspenseWithToast>
      </DashboardLayout>
    </main>
  </div>
</template>

<style scoped lang="scss">
.main-view {
  background-color: var(--color-background);
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  padding: 0;
  margin: 0 auto;

  &__header {
    max-width: 7.2rem;
    flex: 1;
  }

  &__main {
    flex: auto;
  }
}
</style>
